<template>
	<div>
		<Clist :Cuentas="{isCuentas:true}" :regresar="false" :ShowFilas="false" :pShowBtnAdd="false" @FiltrarC="Lista" :Filtro="Filtro" :Nombre="NameList" :pConfigLoad="ConfigLoad">
			<template slot="Filtros">
				<div class="form-group mr-2">
					<label for="">Cliente</label>
				</div>
				<div class="form-group mr-2" style="max-width: 16rem">
					<treeselect
						@input="Lista();GetListaPropiedades();"
						:options="ListaClientes"
						placeholder="Busque un Cliente..."
						v-model="Filtro.IdCliente"
						:disable-fuzzy-matching="true"
					/>
				</div>
				<div class="form-group mr-2">
					<label for="">Propiedad</label>
				</div>
				<div class="form-group mr-2" style="max-width: 16rem">
					<treeselect
						@input="Lista();"
						:options="ListaPropiedades"
						placeholder="Busque una Propiedad..."
						v-model="Filtro.IdClienteS"
						:disable-fuzzy-matching="true"
					/>
				</div>
			</template>
			<template slot="Botonnuevo">
            <div class="col-lg-6 d-flex justify-content-end mt-2 pr-5">
                <!-- <span class="ml-3 titulosmonitoreo">Total de Equipos: </span> <span class="titulosmonitoreo text-primary"> {{ CantidadEquipos }}</span> -->
                <span class="ml-3 titulosmonitoreo">Valor Oportunidad + 15 Años: <span class="titulosmonitoreo text-danger">{{ $formatNumber(MontoEquiposMas15Anios,'$',false) }}</span> </span>
				<span class="ml-3 titulosmonitoreo">Valor Oportunidad 15 y 12 Años: <span class="titulosmonitoreo naranja">{{ $formatNumber(MontoEquipos1512Anios,'$',false) }}</span> </span>
				<span class="ml-3 titulosmonitoreo">Valor Oportunidad 12 y 10 Años: <span class="titulosmonitoreo text-primary">{{ $formatNumber(MontoEquipos1210Anios,'$',false) }}</span> </span>
                <br>
            </div>
        </template>
			<template slot="header">
				<tr>
					<th>Año de vida</th>
					<th>Id Equipo</th>
					<th>Id Activo</th>
					<th>Marca</th>
					<th>Modelo</th>
					<th>Número de serie</th>
					<th>Tipo de unidad</th>
					<th>Cliente</th>
					<th>Propiedad</th>
					<th>Valor aproximado</th>
					<th>Estatus</th>
					<th>Acciones</th>
				</tr>
			</template>
			<template slot="body">
				<tr v-for="(item,index) in ListEquipos" :key="index">
					<td :class="'text-center bold '+ColorNumero(item.Color)">{{item.AnioVida}}</td>
					<td>{{item.CodigoActivo}}</td>
					<td v-b-tooltip.hover.top :title="item.Nequipo">{{$limitCharacters(item.Nequipo,20)}}</td>
					<td>{{item.Marca}}</td>
					<td>{{item.Modelo}}</td>
					<td v-b-tooltip.hover.top :title="item.Serie">{{$limitCharacters(item.Serie,15)}}</td>
					<td v-b-tooltip.hover.top :title="item.Unidad">{{$limitCharacters(item.Unidad,20)}}</td>
					<td v-b-tooltip.hover.top :title="item.Cliente">{{$limitCharacters(item.Cliente,20)}}</td>
					<td v-b-tooltip.hover.top :title="item.Propiedad">{{$limitCharacters(item.Propiedad,20)}}</td>
					<td>$ {{isNaN(parseInt(item.Valor)) ? 0 : formateoMillon(parseInt(item.Valor))}}</td>
					<td class="text-center">
						<div v-b-tooltip.hover :title="item.Status" :class="DefinirClaseActivo(item.Status)"></div>
					</td>
					<td class="text-center">
						<button @click="VerEquipo(item)" type="button" v-b-tooltip.hover title="Ver Equipo" class="btn-icon mr-2"><i class="fa fa-eye"></i></button>
					</td>
				</tr>
			</template>
		</Clist>
	</div>
</template>

<script>
import Clist from "@/components/Clist";
export default {
	name:'oportunidadequipo',
	components:{Clist},
	data() {
		return {
			NameList:"Oportunidades Equipos",
			Filtro:{
				Nombre:'',
                Placeholder:'Nombre/Marca/Modelo/Id Activo...',
                TotalItem:0,
                Pagina:1,
				Entrada:20,
				IdCliente:null,
				IdClienteS:null
			},
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			},
			ListEquipos:[],
			ListaClientes:[],
			ListaPropiedades:[],
			MontoEquipos:0,
			MontoEquiposMas15Anios:0,
			MontoEquipos1512Anios:0,
			MontoEquipos1210Anios:0,
			CantidadEquipos:0
		}
	},
	methods: {
		async Lista(){
			this.ConfigLoad.ShowLoader = true;
			await this.$http.get('equipos/oportunidad',{
				params:{
					Nombre:this.Filtro.Nombre,
					Entrada:this.Filtro.Entrada,
                    pag:this.Filtro.Pagina,
					IdCliente:this.Filtro.IdCliente,
					IdClienteS:this.Filtro.IdClienteS,
				}
			}).then((res)=>{
				this.ListEquipos=res.data.data.equipos;
				this.CantidadEquipos=res.data.data.contador;
				this.MontoEquipos=res.data.data.suma;
				this.MontoEquiposMas15Anios=res.data.data.sumamas15anios;
				this.MontoEquipos1512Anios=res.data.data.suma1512anios;
				this.MontoEquipos1210Anios=res.data.data.suma1210anios;
				this.Filtro.Entrada=res.data.data.pagination.PageSize;
                this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader=false;
			})
		},
		formateoMillon(numero){
            let fixed = 0;
			let e=0;
			if (numero === null) {
				return null;
			} // terminate early
			if (numero === 0) {
				return "0";
			} // terminate early
			fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
			var b = numero.toPrecision(2).split("e"), // get power
				k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
				c =
					k < 1
						? numero.toFixed(0 + fixed)
						: (numero / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
				d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
				if (k==0) {
					// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
					e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}
				else{
					e = d + ["", " M", " B", " T"][k]; // append power
				}
			return e;
        },
		async GetListaClientes(){
            await this.$http.get("clientes/get"
			).then((res)=>{
				let ListaClientes=res.data.data.clientes.map(function(obj){
					return {id:obj.IdCliente,label:obj.Nombre}
				});
				this.ListaClientes=ListaClientes;
			});
        },
		async GetListaPropiedades(){
			this.Filtro.IdClienteS=null;
			this.$http.get("clientesucursal/get",{
				params:{
					Todos:true,
					RegEstatus:'A',
					IdCliente:this.Filtro.IdCliente
				}
			}).then((res)=>{
				this.ListaPropiedades=res.data.data.sucursal.map(function(obj){
					return {id:obj.IdClienteS,label:obj.Nombre}
				});
			})
		},
		VerEquipo(item){
			// console.log(item);
			this.$router.push({name:'mon_histequipo',params:{
					ocliente:item.ClienteObj,
					oClienteSucursal:item.ClienteSObj,
					oEquipo:item,
					pOrigen:'oportunidadequipo'
				}
			});
		},
		ColorNumero(Color){
			let Clase='';
			switch (Color) {
				case 'rojo':
					Clase='text-danger';
					break;
				case 'naranja':
					Clase='naranja';
					break;
				default:
					break;
			}
			return Clase;
		},
		DefinirClaseActivo(Status){
            let Clase="";
            switch (Status) {
                case "Operando":
                    Clase="circuloStatusOperando";
                    break;
                case "En Observacion":
                    Clase="circuloStatusObservacion";
                    break;
                case "Fuera de Servicio":
                    Clase="circuloStatusFueraServicio";
                    break;
                case "En Servicio":
                    Clase="circuloStatusServicio";
                    break;
                default:
                    Clase="circuloStatusDefault";
                    break;
            }
            return Clase;
        },
	},
	mounted() {
		this.Lista();
		this.GetListaClientes();
	},
}
</script>

<style>

</style>
